module.exports = __webpack_public_path__ + "static/media/date-updated.96f4bc0f.svg";